import Shepherd from 'shepherd.js';

import { AIChatbotEvents, trackAIChatbotEvent } from 'Analytics/ai-chatbot-events';

const _DESKTOP_BREAKPOINT = 992;

const VaiaProductTour = (compact = false) => {
    const addProgress = () => {
        const currentStep = tour?.getCurrentStep();
        const currentStepElement = currentStep?.getElement();
        const footer = currentStepElement?.querySelector('.shepherd-footer');
        const progress = document.createElement('span');

        progress.innerText = `${tour?.steps.indexOf(currentStep) + 1} of ${tour?.steps.length}`;
        progress.classList.add('shepherd-progress');

        footer?.insertAdjacentElement('afterbegin', progress);
    };

    const compactAttachTo = (() => {
        if (window.innerWidth < _DESKTOP_BREAKPOINT) {
            return {
                element: '.js_vmChatbotInlineMobileTrigger .js_chatbotPlaceholderSuggestion:first-of-type',
                on: 'bottom-start',
            };
        }

        return {
            element: '.js_vmChatbotInline .js_chatbotPlaceholderSuggestion:nth-child(1)',
            on: 'left',
        };
    })();

    const compactSteps = [
        {
            id: 'vaia-product-tour-step-compact-1',
            title: 'Click here to read the summary <i class="icon icon-chatbot"></i>',
            text: "Generate an AI summary and review what's discussed in this presentation.",
            attachTo: compactAttachTo,
            buttons: [],
            when: {
                show() {
                    trackAIChatbotEvent(AIChatbotEvents.TOOLTIP_APPEAR);
                },
            },
        },
    ];

    const desktopSteps = [
        {
            id: 'vaia-product-tour-step-1',
            title: 'Save time with Vumedi AI <i class="icon icon-chatbot"></i>',
            text: 'Ask for the main points in a presentation. Responses come from the video’s transcript.',
            attachTo: {
                element: '.js_vmChatbotInline .js_chatbotPlaceholderSuggestion:nth-child(3)',
                on: 'left-start',
            },
            buttons: [
                {
                    action() {
                        trackAIChatbotEvent(AIChatbotEvents.INFO_MODAL_CLICKED);
                        return this.next();
                    },
                    classes: 'vm-button vm-button--sm vm-button--secondary',
                    text: 'Next',
                },
            ],
            extraHighlights: ['.js_vmChatbotInline'],
            when: {
                show() {
                    trackAIChatbotEvent(AIChatbotEvents.INFO_MODAL_APPEAR);
                },
            },
        },
        {
            id: 'vaia-product-tour-step-2',
            title: 'Click the button to try it now <i class="icon icon-chatbot"></i>',
            text: 'Quickly generate an AI summary while you watch the video.',
            attachTo: {
                element: '.js_vmChatbotInline .js_chatbotPlaceholderSuggestion:nth-child(1)',
                on: 'left-start',
            },
            buttons: [
                {
                    action() {
                        return this.next();
                    },
                    classes: 'vm-button vm-button--sm vm-button--secondary vm-button--try-it-now',
                    text: 'Try it now',
                },
            ],
            when: {
                show() {
                    trackAIChatbotEvent(AIChatbotEvents.TOOLTIP_APPEAR);
                },
            },
        },
    ];

    const mobileSteps = [
        {
            id: 'vaia-product-tour-step-mobile-1',
            title: `<span>New Update</span><span>Save time with Vumedi AI</span>`,
            text: 'Ask for the main points in a presentation. Responses come from the video’s transcript.',
            buttons: [
                {
                    action() {
                        trackAIChatbotEvent(AIChatbotEvents.INFO_MODAL_CLICKED);
                        return this.next();
                    },
                    classes: 'vm-button vm-button--sm vm-button--primary',
                    text: 'Continue',
                },
            ],
            when: {
                show() {
                    trackAIChatbotEvent(AIChatbotEvents.INFO_MODAL_APPEAR);
                },
            },
        },
        {
            id: 'vaia-product-tour-step-mobile-2',
            title: 'Tap the button to try it now <i class="icon icon-chatbot"></i>',
            text: 'Quickly generate an AI summary while you watch the video.',
            attachTo: {
                element: '.js_vmChatbotInlineMobileTrigger .js_chatbotPlaceholderSuggestion:first-of-type',
                on: 'bottom-start',
            },
            buttons: [],
            when: {
                show() {
                    trackAIChatbotEvent(AIChatbotEvents.TOOLTIP_APPEAR);
                },
            },
        },
    ];

    const tourClass = (() => {
        if (compact) {
            return 'vm-product-tour--compact';
        }

        if (window.innerWidth < _DESKTOP_BREAKPOINT) {
            return 'vm-product-tour--mobile';
        }

        return 'vm-product-tour--desktop';
    })();

    const tour = new Shepherd.Tour({
        defaultStepOptions: {
            cancelIcon: {
                enabled: false,
            },
            classes: ['vm-product-tour', 'vm-product-tour--vaia', tourClass].join(' '),
            scrollTo: false,
            modalOverlayOpeningRadius: window.innerWidth < _DESKTOP_BREAKPOINT ? 8 : 12,
            when: {
                show() {
                    if (tourClass === 'vm-product-tour--desktop') {
                        addProgress();
                    }
                },
            },
        },
        useModalOverlay: true,
    });

    const closeProductTour = (ev) => {
        let isQuestionClick = false;
        let iterator = ev.target;

        do {
            if (
                iterator.classList.contains('js_chatbotPlaceholderSuggestion') ||
                iterator.classList.contains('vm-button--chatbot-send')
            ) {
                isQuestionClick = true;
                break;
            }
        } while ((iterator = iterator?.parentElement));

        if (isQuestionClick) {
            tour.cancel();
        }
    };

    const toggleCollapseButton = (display = false) => {
        const target = document.querySelector('.js_vmChatbotInline .js_chatbotCollapse');

        if (!target) {
            return;
        }

        if (display) {
            target.style.removeProperty('display');
        } else {
            target.style.setProperty('display', 'none');
        }
    };

    const steps = (() => {
        if (compact) {
            return compactSteps;
        }

        if (window.innerWidth < _DESKTOP_BREAKPOINT) {
            return mobileSteps;
        }

        return desktopSteps;
    })();

    steps.forEach((step) => tour.addStep(step));

    tour.on('active', () => {
        document.body.addEventListener('click', closeProductTour);
        toggleCollapseButton();
    });

    tour.on('cancel', () => {
        document.body.removeEventListener('click', closeProductTour);
        toggleCollapseButton(true);
    });

    tour.on('complete', () => {
        document.body.removeEventListener('click', closeProductTour);
        toggleCollapseButton(true);
    });

    return tour;
};

export { VaiaProductTour };
